import { NavigateFunction } from 'react-router-dom';

export const NavigateToTournamentsPage = (
  navigate: NavigateFunction,
  id: number
) => {
  navigate(`/tournaments/list`, {
    state: {
      id,
    },
  });
};
